import {JSX} from "react";
import {storage} from "utils";
import {ButtonLoaderId} from "interfaces";
import {initialState} from "./initial-state";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";

export const layout = createSlice({
  name: "layout",
  initialState,
  reducers: {
    toggleOverlap: function (state, action: PayloadAction<boolean>) {
      state["showOverlap"] = action["payload"];
    },
    toggleFullScreenLoader: function (state, action: PayloadAction<boolean>) {
      state["showFullScreenLoader"] = action["payload"];
    },
    toggleMenu: function (state, action: PayloadAction<boolean>) {
      storage["set"]("[menu-expanded]", action["payload"]);
      state["menuExpanded"] = action["payload"];
    },
    toggleMobileMenu: function (state, {payload}: PayloadAction<boolean>) {
      state["showOverlap"] = payload;
      state["showMobileMenu"] = payload;
    },
    togglePanel: function (
      state,
      action: PayloadAction<
        | {type: "open"; component: JSX.Element; width?: string; title: string}
        | {type: "close"}
      >
    ) {
      const {type} = action["payload"];
      if (type === "open") {
        state["panel"]["opened"] = true;
        state["panel"]["title"] = action["payload"]["title"];
        state["panel"]["component"] = action["payload"]["component"];
        state["panel"]["width"] = action["payload"]["width"] ?? "400px";
      } else {
        state["panel"]["title"] = "";
        state["panel"]["opened"] = false;
        state["panel"]["width"] = undefined;
        state["panel"]["component"] = undefined;
      }
    },
    toggleButtonLoaderId: function (
      state,
      action: PayloadAction<ButtonLoaderId>
    ) {
      const buttonId = action["payload"];
      if (state["buttonLoaderIds"].includes(action["payload"])) {
        state["buttonLoaderIds"] = state["buttonLoaderIds"].filter(
          (c) => c !== buttonId
        );
      } else {
        state["buttonLoaderIds"].push(buttonId);
      }
    },
  },
});

export default layout["reducer"];
export const {
  toggleMenu,
  togglePanel,
  toggleOverlap,
  toggleMobileMenu,
  toggleButtonLoaderId,
  toggleFullScreenLoader,
} = layout["actions"];
